<div class="power-supply-selection-dialog">
  <p class="text-center" mat-dialog-title>{{ powerSupplyData.title }}</p>

  <mat-dialog-content>
    <div *ngIf="powerSupplyData.powerSupplyList && powerSupplyData.powerSupplyList.length > 0" class="power-supply-list">
      <button
        *ngFor="let powerSupply of powerSupplyData.powerSupplyList; trackBy: trackByPowerSupplyId"
        class="power-supply-item"
        type="button"
        (click)="selectPowerSupply(powerSupply)">
        <div class="power-supply-details">
          <p class="power-supply-name text-type-bold">
            {{ powerSupply.powerSupplyName }}
          </p>
          <p *ngIf="powerSupply.nodeName" class="power-supply-info">
            <span class="info-label">Node Name:</span>
            <span class="info-value">{{ powerSupply.nodeName }}</span>
          </p>
          <p class="power-supply-info">
            <span class="info-label">MAC Address:</span>
            <span class="info-value">{{ getMacAddressDisplay(powerSupply) }}</span>
          </p>
        </div>
      </button>
    </div>

    <p *ngIf="!powerSupplyData.powerSupplyList || powerSupplyData.powerSupplyList.length === 0" class="no-results">
      No power supplies found.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button (click)="onCancel()">Cancel</button>
  </mat-dialog-actions>
</div>
